<template>
  <v-fade-transition mode="out-in">
    <v-img
      :key="$route.path"
      :src="heroImage"
      :class="bigSmall()"
    >
      <v-fade-transition mode="out-in">
        <v-container
          fill-height
          :key="$route.path"
          v-if="isBooted"
        >
          >
          <v-layout>
            <v-fade-transition mode="out-in">
            </v-fade-transition>
          </v-layout>
        </v-container>
      </v-fade-transition>
    </v-img>
  </v-fade-transition>
</template>

<script>
export default {
  data: () => ({
    isBooted: false
  }),

  methods: {
    bigSmall() {
      if (window.screen.availWidth > 1400) {
        return "big";
      } else {
        return "small";
      }
    }
  },

  computed: {
    isHome() {
      return this.$route.path === "/";
    },
    namespace() {
      return this.$route.name;
    },
    title() {
      return this.$t(`Views.${this.namespace}.jumbotronTitle`);
    },
    subTitle() {
      return this.$t(`Views.${this.namespace}.jumbotronSubTitle`);
    },
    heroImage() {
      if (this.namespace) {
        return `/static/hero/${this.namespace.toLowerCase()}-hero.png`;
      }
      return;
    }
  },

  mounted() {
    setTimeout(() => {
      this.isBooted = true;
    }, 200);
  }
};
</script>

<style scoped>
.big {
  height: 45vh;
}
.small {
  height: 45vh;
}
</style>
